/**
 * The parts of a patient's pick-list contact line (CLA-1634), shared by
 * `PatientContactLine` and the command palette. Mobile, email, suburb — in
 * full, in that order, blanks dropped. Never the street address.
 */
export interface PatientContactFields {
  phone?: string | null
  email?: string | null
  suburb?: string | null
}

/** The parts of the line, in display (and keep-longest) order. */
export function patientContactParts(p: PatientContactFields): string[] {
  return [p.phone ? displayPhone(p.phone) : p.phone, p.email, p.suburb]
    .map((v) => (typeof v === 'string' ? v.trim() : ''))
    .filter((v) => v.length > 0)
}

/**
 * A phone number the way people write it. Numbers stored in E.164 (the
 * patient import stores `+61491570006`) read as the rest of the list does:
 * `0491 570 006`, `(03) 9123 4567`, `(212) 555-0100`. Anything else is shown
 * as stored.
 */
export function displayPhone(phone: string): string {
  const p = phone.trim()
  let m = p.match(/^\+614(\d{2})(\d{3})(\d{3})$/)
  if (m) return `04${m[1]} ${m[2]} ${m[3]}`
  m = p.match(/^\+61([2378])(\d{4})(\d{4})$/)
  if (m) return `(0${m[1]}) ${m[2]} ${m[3]}`
  m = p.match(/^\+1(\d{3})(\d{3})(\d{4})$/)
  if (m) return `(${m[1]}) ${m[2]}-${m[3]}`
  return p
}
